import {onboardingApi} from "./http-client";

export interface KycProcess {
  onboardingId: string;
  userId: string;
  email: string;
  status: string;
  currentPhase: string;
  metamapResourceUrl?: string | null;
  startedAt: string;
  updatedAt: string;
  completedAt?: string | null;
  meta: Record<string, unknown>;
}

export interface KycStats {
  total: number;
  pending: number;
  approved: number;
  rejected: number;
  byStatus: Record<string, number>;
}

export interface KycListResponse {
  items: KycProcess[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

interface ApiResponse<T> {
  data: T;
  status: number;
  message?: string;
}

export interface KycFilters {
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
}

export interface KycUpdateBody {
  status?: string;
  currentPhase?: string;
  meta?: Record<string, unknown>;
}

export const getKycProcesses = async (filters: KycFilters = {}) => {
  return onboardingApi.get<ApiResponse<KycListResponse>>("/bo/kyc", {params: filters});
};

export const getKycById = async (id: string) => {
  return onboardingApi.get<ApiResponse<KycProcess>>(`/bo/kyc/${encodeURIComponent(id)}`);
};

export const getKycStats = async () => {
  return onboardingApi.get<ApiResponse<KycStats>>("/bo/kyc/stats");
};

export const updateKyc = async (id: string, body: KycUpdateBody) => {
  return onboardingApi.patch<ApiResponse<KycProcess>>(`/bo/kyc/${encodeURIComponent(id)}`, {body});
};

export const approveKyc = async (id: string) => {
  return onboardingApi.post<ApiResponse<KycProcess>>(`/bo/kyc/${encodeURIComponent(id)}/approve`);
};

export const rejectKyc = async (id: string, reason?: string) => {
  return onboardingApi.post<ApiResponse<KycProcess>>(`/bo/kyc/${encodeURIComponent(id)}/reject`, {body: {reason}});
};
